<pp-modal
  [ppWidth]="step === EEditAccountUserStep.SHARES_LIST ? 'auto' : '626px'"
  [ppScrollOnDefault]="true"
  [ppNoPadding]="true"
  >
  <ng-container heading> {{ 'save_edit' | ppTranslate }} </ng-container>

  @if (!processing) {
    <ng-container body>
      @if (step === EEditAccountUserStep.SHARES_LIST && !showingMultipleUsersWarning) {
        <pp-account-user-modal-shares-list
          [ppShowInfoBox]="false"
          [ppAccount]="account"
          [ppSelectedWorkspaceIds]="workspaceIds"
          (ppGoBack)="previousStep()"
          [ppShowBulkAccessibleTags]="selectedShares.length === 1"
          (ppShowCustomFieldsTable)="showCustomFieldsTable($event)"
          [ppEmailsReadOnly]="true"
        ></pp-account-user-modal-shares-list>
      }
      @if (step === EEditAccountUserStep.SHARES_LIST && showingMultipleUsersWarning) {
        <pp-account-user-modal-shares-list
          [ppShowInfoBox]="false"
          [ppAccount]="account"
          [ppSelectedWorkspaceIds]="workspaceIds"
          [ppShowBulkAccessibleTags]="true"
          (ppGoBack)="previousStep()"
          (ppShowIndividualCustomFieldsTable)="showIndividualCustomFieldsTable($event)"
          (ppShowBulkCustomFieldsTable)="showBulkCustomFieldsTable()"
          [ppEmailsReadOnly]="true"
          [(ppSelectedShares)]="selectedShares"
        ></pp-account-user-modal-shares-list>
      }
      @if (step === EEditAccountUserStep.CUSTOM_FIELDS_EDIT) {
        <pp-account-user-modal-custom-fields
          [ppBulkEdit]="bulkEditingCustomFields"
          [(ppShares)]="selectedShares"
          [ppWorkspaceId]="customFieldsWorkspaceId"
          [(ppShare)]="editedShare"
        ></pp-account-user-modal-custom-fields>
      }
    </ng-container>
  }

  <ng-container footer>
    <pp-modal-generic-footer
      [ppConfirmText]="confirmText"
      [ppProcess]="processing || savingShare"
      (ppCancel)="previousStep()"
      (ppConfirm)="nextStep()"
    ></pp-modal-generic-footer>
  </ng-container>
</pp-modal>
